// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__330wy","col":"styles_col__1W51Q"};